<template>
  <div>
    <div
      :id="nameDoomNode"
      :style="'overflow: hidden;position: relative; height:' + height"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { v4 as uuidv4 } from "uuid";

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer,
]);

export default {
  name: "BarChart",
  props: {
    data: {
      type: Array,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    height: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      nameDoomNode: "bar-content-" + uuidv4(),
      myChart: null,
    };
  },
  watch: {
    data(newData, oldData) {
      if (this.myChart && newData !== oldData) {
        this.renderChart();
      }
    },
  },
  mounted() {
    const dom = document.getElementById(this.nameDoomNode);
    this.myChart = echarts.init(dom, null, {
      renderer: "svg",
      useDirtyRect: false,
    });
    this.renderChart();

    window.addEventListener("resize", this.myChart.resize);
  },
  methods: {
    renderChart() {
      const labels = this.data.map((d) => d.name);
      const values = this.data.map((d) => d.value);
      const ids = this.data.map((d) => d._id);

      const option = {
        title: {
          text: this.title,
          left: "center",
          textStyle: {
            fontSize: "12px",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: labels,
        },
        series: [
          {
            name: this.tipo,
            type: "bar",
            data: this.data.map((item) => ({
              value: item.value,
              name: item.name,
              _id: item._id,
              itemStyle: {
                color:
                  this.colors.length > 0
                    ? this.colors[labels.indexOf(item.name) % this.colors.length]
                    : undefined,
              },
            })),
            label: {
              show: true,
              position: "right",
            },
          },
        ],
      };

      this.myChart.setOption(option);

      this.myChart.off("click"); // remove previous listeners
      this.myChart.on("click", (params) => {
        if (params.name) {
          this.$emit("chart-click", {
            selectedValue: params.name,
            _id: params.data._id,
            tipe: this.tipo,
          });
        }
      });
    },
  },
};
</script>
